import React, { FunctionComponent, useEffect, useState } from 'react';
import ScrollToWrapper from '../../../../presentational/ScrollToWrapper';
import { useSelector } from 'react-redux';
import ChangeModel from '../changeModel/ChangeModel';
import VariantCategoryTabsContainer from '../VariantCategoryTabsContainer';
import VariantListContainer from '../VariantListContainer';
import SpecificationsModal from '../specificationsModal/SpecificationsModal';
import VariantSelectorBase from '../../../../../../common/components/variantSelector/variantSelectorBase/VariantSelectorBase';
import optionsSelectors from '../../../../../store/selectors/optionsSelectors';
import { getVariantDetails } from '../../../../../store/selectors/variantDetailsSelectors';

const VariantSelectorContainer: FunctionComponent = () => {
  const [expanded, setExpanded] = useState(true);
  const optionsError = useSelector(optionsSelectors.getOptionsErrorState);
  const variantDetails = useSelector(getVariantDetails);
  const [selectedMarketingCategory, setMarketingCategory] = useState(null);

  useEffect(() => {
    setMarketingCategory(variantDetails?.marketingCategory);
  }, [variantDetails?.marketingCategory]);

  return (
    <ScrollToWrapper target="variant">
      <VariantSelectorBase expanded={expanded} setExpanded={setExpanded} error={optionsError}>
        <ChangeModel />
        <VariantCategoryTabsContainer
          setMarketingCategory={setMarketingCategory}
          selectedMarketingCategory={selectedMarketingCategory}
        />
        <VariantListContainer selectedMarketingCategory={selectedMarketingCategory} />
        <SpecificationsModal />
      </VariantSelectorBase>
    </ScrollToWrapper>
  );
};

export default VariantSelectorContainer;
